import { render } from "./Authorized.vue?vue&type=template&id=a9f2f7e8&scoped=true"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"

import "./Authorized.vue?vue&type=style&index=0&id=a9f2f7e8&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f2f7e8"]])

export default __exports__